export class Designation {
    id: number;
    name: string;
    active: string;
    designationLevelId: number;
    careerLevel: string;
}